import './ToolBar.css'

import { Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { IMAGES } from 'assets'
import { formatDateWithPadding, formatDtweekOptions } from 'commons/utilities'
import { CustomCheckbox, Image, SearchCalendar, SearchFormInput, SelectInput } from 'components/commons'
import { TABLE_WIDTH, TOOLBAR_TYPE } from 'constants/constant'
// import { useEffect } from 'react'
// import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// import styles from './ToolBarStyles'
// import { useHistory } from 'react-router-dom'
import filterIcon from '../../../assets/img/filter-solid.svg'
import arrowRight from '../../../assets/img/play-solid.svg'
import createIcon from '../../../assets/img/plus-solid.svg'
// import { CSVLink } from 'react-csv'
import { handleDownload2 } from '../../../commons/utilities'
import SelectInputCalendar from '../FormInputs/SelectInputCalendar'

function ToolBar({
  listToolBarComponent = [],
  setShowModal,
  handleCreateOnclick,
  setSearchData,
  setSearchInput,
  searchInput,
  handleSubmit,
  setFilterItem,
  customClassName = '',
  filterItem,
  filterLabel,
  setSelectedDate,
  handleFilterDate,
  selectedDate = formatDateWithPadding(new Date(), 'yyyy-MM-dd'),
  // headerCsvLabel,
  // headerCsvKey,
  // listData,
  // fileCsvName = '',
  // confirmEdit,
  CustomDropdownClassName = '',
  csvButtonStyle = false,
  canDownloadData = true,
  downloadParams,
  toolbarWidth = ' ',
  setIsValidDate,
  setIsInDateRange,
  approvalListItems,
  hqConfirmListItems,
  handleUpdateApproval,
  handleUpdateHqConfirm,
  handleUpdateCompliance,
  complianceKbEdit,
  approvalItem,
  hqConfirmItem,
  listFilterItem,
  toolbarNoHeight = false,
  toolbarNoHeightPaddingTop = false,
  toolbarNoHeightPaddingBottom = false,
  handleSelectFolderName,
  undownloaded = true,
  setUndownloaded,
  handleFilterByUndownloaded,
  screen,
  handleDowloadCsv,
  handleGoBack,
  filterItemDtWeek,
  setFilterItemDtWeek,
  listDtWeekOption,
  setFilterItemYmRegist,
  filterItemYmRegist,
  listYmRegistOption,
  listYmRegist,
  hasFilterIcon = true,
  customClassTitleFitlerIcon = '',
  totalTableWidth = null,
}) {
  const { i18n, t } = useTranslation()

  const ArrowRight = () => (
    <img
      src={arrowRight}
      alt="ArrowRight Icon"
      className="icon-redirect"
      onClick={() => {
        setShowModal(true)
      }}
    />
  )
  const CreateIcon = () => (
    <img src={createIcon} alt="Create Icon" className="icon-redirect" onClick={handleCreateOnclick} />
  )

  const FilterIcon = () => <img src={filterIcon} alt="Filter Icon" className="icon-filter" />
  const FilterIconOnly = () => <img src={filterIcon} alt="Filter Icon" className="icon-filter-only" />

  const getToolBarComponent = (toolbar = {}, index = 0) => {
    let component = null
    switch (toolbar.type) {
      /* PREVIEW */
      case TOOLBAR_TYPE.PREVIEW:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <ArrowRight />
          </div>
        )
        return component
      /* CREATE */

      case TOOLBAR_TYPE.ADD:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <CreateIcon />
          </div>
        )
        return component
      /* DOWNLOAD */

      case TOOLBAR_TYPE.DOWNLOAD:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <Image src={IMAGES.ICON.DOWNLOAD_ICON} className="icon-action" onClick={() => {}} />
          </div>
        )
        return component
      /* CHECKBOX */

      case TOOLBAR_TYPE.CHECKBOX:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <CustomCheckbox
              label={t('downloadStatus.lblNotDownloaded')}
              checked={Boolean(Number(undownloaded))}
              onChange={(e) => {
                setUndownloaded(Number(e))
                handleFilterByUndownloaded(Number(e))
              }}
              className="checkbox"
            />
          </div>
        )
        return component

      case TOOLBAR_TYPE.CHECKBOX_DISABLE:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <CustomCheckbox
              label={t('downloadStatus.lblNotDownloaded')}
              checked={Boolean(Number(undownloaded))}
              disabled={true}
              onChange={(e) => {
                setUndownloaded(Number(e))
                handleFilterByUndownloaded(Number(e))
              }}
              className="checkbox"
            />
          </div>
        )
        return component
      /* FILTER FIELD */

      case TOOLBAR_TYPE.FILTER_LOGO:
        component = (
          <div className={`${toolbar.commonStyle}  ${customClassName}`} key={index}>
            {hasFilterIcon && <FilterIcon />}
            {filterLabel ? (
              <span className="toolbar-text filterWeek-label">{filterLabel}</span>
            ) : (
              <span className="toolbar-text">{t('maintenance.lblFilterText')}</span>
            )}
          </div>
        )
        return component

      case TOOLBAR_TYPE.FILTER_LOGO_ONLY:
        component = (
          <div className={`${toolbar.commonStyle} ${customClassName}`} key={index}>
            <FilterIconOnly />
          </div>
        )
        return component
      /* SEARCH */

      case TOOLBAR_TYPE.SEARCH:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <div className={`${toolbar.componentStyle}`}>
              <SearchFormInput
                setSearchData={setSearchData}
                setSearchInput={setSearchInput}
                searchInput={searchInput}
                handleSubmit={handleSubmit}
              />
            </div>
          </div>
        )
        return component

      /* TURN_BACK */
      case TOOLBAR_TYPE.TURN_BACK:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <div className={`${toolbar.componentStyle}`}>
              <ArrowBackIcon
                onClick={() => {
                  handleGoBack()
                }}
                className="arrow-back-icon"
              />
            </div>
          </div>
        )
        return component

      case TOOLBAR_TYPE.SEARCH_LEFT:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <div className={`${toolbar.componentStyle}`}>
              <SearchFormInput
                setSearchData={setSearchData}
                setSearchInput={setSearchInput}
                searchInput={searchInput}
                handleSubmit={handleSubmit}
              />
            </div>
          </div>
        )
        return component
      /* SELECT DATE */

      case TOOLBAR_TYPE.FILTER_DATE:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <SelectInput
              itemType={'filter'}
              onChange={(v) => setFilterItem(v.target.value)}
              value={filterItem}
              items={[
                { value: t('commonComponent.toolBar.lblStartDate'), label: t('commonComponent.toolBar.lblStartDate') },
                { value: t('commonComponent.toolBar.lblEndDate'), label: t('commonComponent.toolBar.lblEndDate') },
              ]}
              icon={''}
              name="select_item--toolbar"
              variant="outlined"
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 10,
                  horizontal: 0,
                },
                getContentAnchorEl: null,
              }}
            />
          </div>
        )
        return component

      case TOOLBAR_TYPE.FOLDER_SELECT:
        component = (
          <div
            className={`${toolbar.commonStyle} ${window.location.href.includes('download') ? 'select-download' : ''}`}
            key={index}
          >
            <SelectInput
              itemType={'filter'}
              onChange={(e) => {
                setFilterItem(e.target.value)
                handleSelectFolderName(e.target.value)
              }}
              CustomDropdownClassName={CustomDropdownClassName}
              value={filterItem}
              items={listFilterItem}
              icon={''}
              name="select_item--toolbar"
              variant="outlined"
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 10,
                  horizontal: 0,
                },
                getContentAnchorEl: null,
              }}
            />
          </div>
        )
        return component

      /* CALENDAR */

      case TOOLBAR_TYPE.CALENDAR:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <div className={`${toolbar.componentStyle}`}>
              <SearchCalendar
                inputVariant="outlined"
                formatDate="yyyy-MM-dd"
                setIsValidDate={setIsValidDate}
                setIsInDateRange={setIsInDateRange}
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(formatDateWithPadding(e, 'yyyy-MM-dd'))
                  // saveDateWithDownloadDetailComp(formatDateWithPadding(e, 'yyyy-MM-dd'))
                }}
                PopoverProps={{
                  anchorOrigin: { horizontal: 0, vertical: 'bottom' },
                  transformOrigin: { horizontal: 0, vertical: 8 },
                }}
                onSubmit={(date) => {
                  handleFilterDate(date)
                }}
              />
            </div>
          </div>
        )
        return component

      case TOOLBAR_TYPE.WEEK_CALENDAR:
        component = (
          <div key={index}>
            <div className="dt-week-calendar-container ">
              <div className="year-month-calendar-item">
                <SelectInputCalendar
                  itemType={'filter'}
                  onChange={(e) => {
                    setFilterItemDtWeek(e.target.value)
                    handleFilterDate(e)
                  }}
                  // onBlur={(e) => {
                  //   handleFilterDate(e)
                  //   setSelectedDate(currentDate)
                  // }}
                  value={filterItemDtWeek}
                  items={listDtWeekOption.map((data) => ({
                    ...data,
                    label: formatDtweekOptions(data.label),
                  }))}
                  icon={''}
                  name="select_item--toolbar"
                  variant="outlined"
                  inputProps={{ className: 'item-year' }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 10,
                      horizontal: 0,
                    },
                    getContentAnchorEl: null,
                  }}
                />
              </div>
            </div>
          </div>
        )
        return component

      case TOOLBAR_TYPE.YEAR_MONTH_CALENDAR:
        component = (
          <div key={index}>
            <div className="year-month-calendar-container">
              <div className="year-month-calendar-item">
                <SelectInputCalendar
                  itemType={'filter'}
                  onChange={(e) => {
                    setFilterItemYmRegist(e.target.value)
                    handleFilterDate(e)
                  }}
                  value={filterItemYmRegist}
                  items={listYmRegistOption}
                  icon={''}
                  name="select_item--toolbar"
                  variant="outlined"
                  inputProps={{ className: 'item-year' }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 10,
                      horizontal: 0,
                    },
                    getContentAnchorEl: null,
                  }}
                />
              </div>
            </div>
          </div>
        )
        return component
      /*EXPIRE_DATE */
      case TOOLBAR_TYPE.EXPIRE_DATE:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <span className="toolbar-text">{t('headquarter.lblExpiredDate')}</span>
          </div>
        )
        return component

      /*SENDING_DATE */
      case TOOLBAR_TYPE.SENDING_DATE:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <span className="toolbar-text">{t('downloadStatus.lblSendingDate')}</span>
          </div>
        )
        return component

      /*TIME_LABEL */
      case TOOLBAR_TYPE.TIME_LABEL:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <span className="timelablel-text">{t('portal.lbl_timeStamp')}</span>
          </div>
        )
        return component
      /* COMPLIANCE_CHECKBOX */
      case TOOLBAR_TYPE.COMPLIANCE_CHECKBOX:
        component = (
          <div key={index}>
            <CustomCheckbox
              label={t('compliance.lblCorrectionCheckbox')}
              checked={Boolean(Number(complianceKbEdit))}
              onChange={(e) => handleUpdateCompliance('KB_EDIT', e)}
              className="checkbox checkbox-compliance"
            />
          </div>
        )
        return component
      /* APPROVAL_SELECT */
      case TOOLBAR_TYPE.APPROVAL_SELECT:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <div className="toolbar-text apporval-label">{t('compliance.lblApproval')}</div>
            <SelectInput
              itemType={'filter'}
              onChange={(v) => handleUpdateApproval(v.target.value)}
              value={approvalItem}
              items={approvalListItems}
              icon={''}
              name="select_item--toolbar"
              variant="outlined"
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 10,
                  horizontal: 0,
                },
                getContentAnchorEl: null,
              }}
            />
          </div>
        )
        return component
      /* HEAD_QUARTERS_CONFIRM_SELECT */
      case TOOLBAR_TYPE.HEAD_QUARTERS_CONFIRM_SELECT:
        component = (
          <div className={`${toolbar.commonStyle}`} key={index}>
            <div className="toolbar-text hqConfirm-label">{t('compliance.lblHeadQuarterConfirm')}</div>
            <SelectInput
              itemType={'filter'}
              onChange={(v) => handleUpdateHqConfirm(v.target.value)}
              value={hqConfirmItem}
              items={hqConfirmListItems}
              icon={''}
              name="select_item--toolbar"
              variant="outlined"
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 10,
                  horizontal: 0,
                },
                getContentAnchorEl: null,
              }}
            />
          </div>
        )
        return component
      default:
        return ''
    }
  }

  return (
    <div
      className={`${toolbarNoHeight === true ? 'toolbar-no-height' : 'toolbar'} ${
        toolbarNoHeightPaddingTop === true ? 'toolbar-no-height-padding-top' : ''
      }  ${toolbarNoHeightPaddingBottom === true ? 'toolbar-no-height-padding-bottom' : ''} ${
        toolbarWidth === 'SMALL' ? 'toolbar-small' : ''
      }
      ${customClassTitleFitlerIcon}
      `}
      style={totalTableWidth && totalTableWidth > TABLE_WIDTH ? { width: totalTableWidth + 'px' } : {}}
    >
      {/* Action */}
      <div className="actionContainer">
        {listToolBarComponent.map((toolbar, index) => getToolBarComponent(toolbar, index))}
      </div>
      {/* Csv Dowload */}
      {canDownloadData && (
        <div
          className={`csv-container ${csvButtonStyle ? 'csv-style' : ''} ${
            screen === t('compliance.lblScreenName') ? 'widthUnset' : ''
          }`}
        >
          {listToolBarComponent[listToolBarComponent.length - 1].type === TOOLBAR_TYPE.CSV && (
            <div className="btn-download">
              <Button
                variant="contained"
                color="primary"
                onClick={
                  screen === t('compliance.lblScreenName')
                    ? handleDowloadCsv
                    : () => handleDownload2(downloadParams, i18n)
                }
              >
                {t('headquarter.btnDownload')}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ToolBar
